import script from "./CampaignSlotBookings.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignSlotBookings.vue?vue&type=script&setup=true&lang=js"

import "./CampaignSlotBookings.vue?vue&type=style&index=0&id=29ff0ad9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ff0ad9"]])

export default __exports__